import React, { useState } from "react";
import { Collapse, GridLegacy, MenuItem } from "@mui/material";
import Card from "../../../components/Card/Card";
import CardBody from "../../../components/Card/CardBody";
import { printMode, printProtocol } from "../../../variables/app";
import { convertObjectToSelectOptions } from "../../../templateHelpers";
import TranslationWrapper from "../../../components/TranslationWrapper/TranslationWrapper.tsx";
import FormAsyncTC from "../../../components/Forms/FormAsyncTC";
import FormTextTC from "../../../components/Forms/FormTextTC";
import FormSelectTC from "../../../components/Forms/FormSelectTC";
import FormControlledInputTC from "../../../components/Forms/FormControlledInputTC";
import FormSwitchTC from "../../../components/Forms/FormSwitchTC";
import { Controller, useFormContext, useWatch } from "react-hook-form";
import AsynchronousAutocomplete from "../../../components/Autocomplete/AsynchronousAutocomplete";
import FormFieldTwoColumns from "../../../components/Forms/Layouts/FormFieldTwoColumns";

function Algemeen() {
  const { control } = useFormContext();
  const fontFilePath = useWatch({ name: "fontFilePath" });
  const protocol = useWatch({ name: "protocol" });
  const [duplicatePrinterIds, setDuplicatePrinterIds] = useState(null);
  const printProtocolOptions = convertObjectToSelectOptions(printProtocol);
  const printModeOptions = convertObjectToSelectOptions(printMode);

  return (
    <div style={{ width: "100%", height: "100%" }}>
      <Card>
        <CardBody style={{ padding: 16 }}>
          <GridLegacy container spacing={1}>
            <GridLegacy alignContent={"flex-start"} container item lg={6} xs={12}>
              <FormAsyncTC
                async={{
                  url: "core/vestigingen/search?fields=id as value, systeemNaam as label&per_page=50",
                  searchField: "systeemNaam",
                }}
                name={"vestiging_id"}
                nullable={true}
                tDefault={"Vestiging"}
                tKey={"printers.form.algemeen.label.vestiging"}
              />
              <FormSelectTC
                name={"protocol"}
                options={[printProtocolOptions]}
                tDefault={"Print protocol"}
                tKey={"printers.form.algemeen.label.protocol"}
              />
              <FormTextTC name={"name"} tDefault={"Naam"} tKey={"printers.form.algemeen.label.name"} />
              <FormTextTC name={"username"} tDefault={"Username"} tKey={"printers.form.algemeen.label.username"} />
              <FormTextTC name={"password"} tDefault={"Password"} tKey={"printers.form.algemeen.label.password"} />
              <FormTextTC name={"mac"} tDefault={"Mac adres"} tKey={"printers.form.algemeen.label.mac"} />
              <Collapse in={protocol != "" ? protocol != "Cloud" : null} sx={{ width: 1 }}>
                <FormTextTC
                  name={"localPrinterIP"}
                  tDefault={"IP Address"}
                  tKey={"printers.form.algemeen.label.localPrinterIP"}
                />
                <FormSelectTC
                  name={"printMode"}
                  options={[...printModeOptions]}
                  tDefault={"Print mode"}
                  tKey={"printers.form.algemeen.label.printMode"}
                />
                <FormTextTC name={"token"} tDefault={"Socket token"} tKey={"printers.form.algemeen.label.token"} />
                <FormControlledInputTC
                  defaultValue={64}
                  name={"characters"}
                  rules={{
                    min: {
                      value: 32,
                      message: <TranslationWrapper tKey={"The value must be higher or equal to 32!"} />,
                    },
                  }}
                  tDefault={"Characters"}
                  tKey={"printers.form.algemeen.label.characters"}
                  type={"number"}
                />
                <FormControlledInputTC
                  name={"retryInterval"}
                  rules={{
                    min: {
                      value: 10,
                      message: <TranslationWrapper tKey={"The value must be higher or equal to 10!"} />,
                    },
                  }}
                  tDefault={"Retry interval"}
                  tKey={"printers.form.algemeen.label.retryInterval"}
                  type={"number"}
                />
                <FormTextTC
                  name={"fontFilePath"}
                  tDefault={"TTF font location"}
                  tKey={"printers.form.algemeen.label.fontFilePath"}
                />
                <Collapse in={fontFilePath} sx={{ width: 1 }}>
                  <FormControlledInputTC
                    name={"fontSize"}
                    rules={{
                      min: {
                        value: 0,
                        message: <TranslationWrapper tKey={"The value must not be negative!"} />,
                      },
                    }}
                    tDefault={"Fontsize"}
                    tKey={"printers.form.algemeen.label.fontSize"}
                    type={"number"}
                  />
                  <FormControlledInputTC
                    name={"fontSizeWb"}
                    rules={{
                      min: {
                        value: 0,
                        message: <TranslationWrapper tKey={"The value must not be negative!"} />,
                      },
                    }}
                    tDefault={"Fontsize kitchen tickets"}
                    tKey={"printers.form.algemeen.label.fontSizeWb"}
                    type={"number"}
                  />
                </Collapse>
              </Collapse>
              <FormControlledInputTC
                name={"printCount"}
                rules={{
                  min: {
                    value: 0,
                    message: <TranslationWrapper tKey={"The value must not be negative!"} />,
                  },
                }}
                tDefault={"Printer count"}
                tKey={"printers.form.algemeen.label.printCount"}
                type={"number"}
              />
              <FormSwitchTC
                name={"usePrintName"}
                tDefault={"Use printname"}
                tKey={"printers.form.algemeen.label.usePrintName"}
              />
              <FormSwitchTC
                name={"print_option_count"}
                tDefault={"Print option count"}
                tKey={"printers.form.algemeen.label.print_option_count"}
              />
              <FormSwitchTC
                name={"alsoPrintName"}
                tDefault={"Also print original name"}
                tKey={"printers.form.algemeen.label.alsoPrintName"}
              />
              <FormSwitchTC
                name={"printZeroValues"}
                tDefault={"Print zero values"}
                tKey={"printers.form.algemeen.label.printZeroValues"}
              />{" "}
              <FormSwitchTC
                name={"printBuzzer"}
                tDefault={"Buzzer enabled (check printer support)"}
                tKey={"printers.form.algemeen.label.printBuzzer"}
              />
              <FormFieldTwoColumns tDefault={"Duplicate to printer"} tKey={"printers.form.algemeen.label.copyPrinter"}>
                <Controller
                  control={control}
                  defaultValue={""}
                  name={"duplicateTo"}
                  render={({ field: { onChange, onBlur, value, name, ref }, fieldState: { error } }) => {
                    return (
                      <AsynchronousAutocomplete
                        async={{
                          url: "core/printers/search?fields=id as value, name as label",
                          searchField: "name",
                          perPage: 50,
                        }}
                        multiple={true}
                        onChange={(e, value) => {
                          setDuplicatePrinterIds(value);
                          value = value.map((printer) => printer.value).join(",");
                          onChange({ target: { value: value } }, value);
                        }}
                        value={
                          duplicatePrinterIds ??
                          value
                            ?.split(",")
                            .filter((id) => id.length > 0)
                            .map((id) => ({ value: Number(id) }))
                        }
                      />
                    );
                  }}
                />
              </FormFieldTwoColumns>
            </GridLegacy>
          </GridLegacy>
        </CardBody>
      </Card>
    </div>
  );
}

export default Algemeen;
